import React, { Component, Fragment } from "react"
import { connect } from "react-redux"
import { compose } from "recompose"
import {
  Dialog,
  DialogActions,
  DialogContent,
  withMobileDialog,
  Tabs,
  Tab,
  CardContent,
  CircularProgress,
} from "@material-ui/core"
// import LoadingButton from "../../components/LoadingButton"
// import Grid from "@material-ui/core/Grid"
// import Button from "@material-ui/core/Button"
import SwipeableViews from "react-swipeable-views"
import styles from "./styles"
import LoadingButton from "../../components/LoadingButton"
import Button from "@material-ui/core/Button"
import { withStyles } from "@material-ui/core/styles"
import { Elements } from "@stripe/react-stripe-js"
import CardForm from "./cardForm"
import { subscribe } from "../../actions/subscribe"
import { openSnackBar } from "../../actions/snack-bar"
import { _updateUser } from "../../actions/users"
import classNames from "classnames"
import { loadStripe } from "@stripe/stripe-js"
import { ElementsConsumer, CardElement } from "@stripe/react-stripe-js"

// import {
//   togglePaymentModal,
//   createBooking,
//   sendBooking
// } from '../../actions/companies'
// import update from 'immutability-helper'
// import InputLabel from '@material-ui/core/InputLabel'
// import Input from '@material-ui/core/Input'
// import FormControl from '@material-ui/core/FormControl'
// import MuiPickersUtilsProvider from 'material-ui-pickers/utils/MuiPickersUtilsProvider'
// import MomentUtils from 'material-ui-pickers/utils/moment-utils'
// import moment from 'moment'
// import { openSnackBar } from '../../actions/snack-bar'

class PaymentModal extends Component {
  constructor(props) {
    super(props)

    this.state = {
      payment: {
        page: 0,
        plan: null,
        loading: false,
      },
      tab: 0,
    }
  }
  // stripeKey = "pk_test_qLE9tUsjTkJYU5xgjmN7CGTa00tBTn6b3Z"
  // stripeKey = process.env.REACT_APP_STRIPE_TEST
  stripeKey =
    process.env.REACT_APP_ENV === "production"
      ? process.env.REACT_APP_STRIPE_LIVE
      : process.env.REACT_APP_ENV === "staging"
        ? process.env.REACT_APP_STRIPE_TEST
        : process.env.REACT_APP_STRIPE_TEST

  // stripeKey = "pk_live_ePZL8ZYpTh9lmXVWdJGGWq9h00Dy6CzZUL"
  stripePromise = loadStripe(this.stripeKey)






  subPage = val => {
    if (this.state.tab !== 0) {
      this.handleClose()
    } else {
      // testing
      this.setState({ payment: { page: 1, plan: "plan_F1udE1zzXvC5iN" } })
      // prod
      // this.setState({ payment: { page: 1, plan: 'prod_F1ucZoj7jAu8AQ' } })
    }
  }

  handleClose = () => {
    this.props.dispatch({ type: "PAYMENT_MODAL", payload: false })
  }

  payment = (event, stripe, elements) => {
    this.setState({ loading: true })
    const coupon = this.cardRef.state.coupon
    const user = this.props.authenticatedUser
    const obj = {
      user_id: user.id,
      plan: this.state.payment.plan,
      name: user.first_name + " " + user.last_name,
      email: user.email,
    }
    const cardElement = elements.getElement(CardElement)

    obj.coupon = coupon.length > 0 ? coupon : undefined
    stripe
      .createToken(cardElement)
      .then(res => {
        if (res.error) {
          throw new Error(res.error.message)
        }
        obj.token = res.token.id
        this.props
          .dispatch(subscribe(obj))
          .then(res => {
            this.setState({ loading: false })
            if (res.message) {
              this.props.dispatch(
                openSnackBar({ message: "Enhanced Crew Profile Purchased" })
              )
              this.handleClose()
              this.props.dispatch(
                _updateUser({
                  id: this.props.authenticatedUser.id,
                  hasMembership: true,
                  membershipValid: true,
                })
              )
            } else {
              this.props.dispatch(openSnackBar({ message: res.error }))
            }
          })
          .catch(err => {
            console.log(err)
            this.props.dispatch(
              openSnackBar({ message: "Error purchasing membership" })
            )
            this.setState({ loading: false })
          })
      })
      .catch(err => {
        console.log({ err })
        this.setState({ loading: false })
        this.props.dispatch(openSnackBar({ message: err.message }))
      })
  }

  handleChange = (e, tab) => {
    this.setState({ tab })
  }

  render() {
    const { fullScreen, classes } = this.props
    return (
      <Fragment>
        <Elements stripe={this.stripePromise}>
          <ElementsConsumer>
            {({ stripe, elements }) => (
              <Dialog
                fullScreen={fullScreen}
                open={this.props.open}
                onClose={this.handleClose}
                onExited={this.clearState}
                aria-labelledby="responsive-dialog-title"
              >
                <DialogContent open={true}>
                  {this.state.payment.page === 0 && (
                    <Fragment>
                      <h2 className={classes.pModalHeader}>
                        {" "}
                        Switch to an Enhanced Profile
                      </h2>
                      <p className={classes.pModal}>
                        Get more shoots by adding clients, video reel, photo
                        gallery, priority in search results, and even more
                        cities, positions, vehicles, & equipment.
                      </p>
                    </Fragment>
                  )}
                  {this.state.payment.page === 1 && (
                    <Fragment>
                      <h2 className={classes.pModalHeader}>
                        Pay for an Enhanced Profile
                      </h2>
                      <p className={classes.pModal}>
                        Enter your credit card to sign-up for an Enhanced
                        Profile and get booked on more shoots.
                      </p>
                      <div
                        className={classNames(classes.textMod, classes.pModal)}
                      >
                        <div>One Year Enhanced Profile </div>
                        <div className={classes.textMod2}>$72</div>
                      </div>
                    </Fragment>
                  )}
                </DialogContent>
                {this.state.payment.page === 0 ? (
                  <DialogContent style={{ overflow: "visible" }}>
                    <div style={{ textAlign: "center" }}>
                      {/* <AppBar position="static" color="default"> */}
                      <Tabs
                        value={this.state.tab}
                        onChange={this.handleChange}
                        indicatorColor="primary"
                        textColor="primary"
                        style={{
                          width: "370px",
                          backgroundColor: "#e1e1e1",
                          boxShadow: "1px 1px 3px rgba(0, 0, 0, .5)",
                          margin: "auto",
                        }}
                      >
                        <Tab label="Enhanced Crew Profile" />
                        <Tab label="Free" />
                      </Tabs>
                      {/* </AppBar> */}
                      <SwipeableViews
                        axis={"x"}
                        index={this.state.tab}
                        onChangeIndex={this.handleChangeIndex}
                      >
                        <p className={classes.pModal}>
                          <b>$6/Month billed yearly</b>
                          <ul>
                            <li>• Priority Search Results</li>
                            <li>• Clients</li>
                            <li>• Video Reel</li>
                            <li>• Photos</li>
                            <li>• 5 Vehicles</li>
                            <li>• 5 Cities</li>
                            <li>• 5 Positions</li>
                            <li>• Unlimited Equipment</li>
                          </ul>
                        </p>
                        <p className={classes.pModal}>
                          <ul>
                            <li>• 2 Cities</li>
                            <li>• 2 Positions</li>
                            <li>• 4 Equipment</li>
                          </ul>
                        </p>
                      </SwipeableViews>
                    </div>
                  </DialogContent>
                ) : (
                  <CardContent>
                    <CardForm onRef={ref => (this.cardRef = ref)} />
                  </CardContent>
                )}
                <DialogActions>
                  <Button
                    color="primary"
                    onClick={() => {
                      if (this.state.payment.page === 1) {
                        this.setState({
                          payment: { ...this.state.payment, page: 0 },
                        })
                      } else {
                        this.handleClose()
                      }
                    }}
                  >
                    Cancel
                  </Button>

                  {this.state.payment.page === 1 ? (
                    <Button
                      onClick={e => this.payment(e, stripe, elements)}
                      variant="contained"
                      color="primary"
                    >
                      {this.state.loading ? (
                        <CircularProgress
                          style={{
                            width: "25px",
                            height: "25px",
                            marginTop: "-2px",
                            color: "white",
                          }}
                        />
                      ) : (
                        "Purchase"
                      )}
                    </Button>
                  ) : (
                    <LoadingButton
                      color="secondary"
                      onClick={() => this.subPage()}
                    >
                      Select
                    </LoadingButton>
                  )}
                </DialogActions>
              </Dialog>
            )}
          </ElementsConsumer>
        </Elements>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  return {
    authenticatedUser: state.authentication.authenticatedUser,
    open: state.paymentModalOpen,
    paymentMaker: state.companies.paymentMaker,
  }
}

export default compose(
  connect(mapStateToProps),
  withMobileDialog(),
  withStyles(styles, { withTheme: true })
)(PaymentModal)
